import { createSlice } from "@reduxjs/toolkit"
import { ErrorType } from "@/shared/types"
import { IOrganization, IContactPerson } from "@/shared/api/onboarding"
import { fetchOrganizationProfile, fetchUpdateContactPerson, fetchSubmitForModeration, fetchDashboardStatus } from "./onboarding-thunk"

interface OnboardingState {
    organization: IOrganization | null
    contact: IContactPerson | null
    isLoading: boolean
    error: ErrorType | null
}

const initialState: OnboardingState = {
    organization: null,
    contact: null,
    isLoading: false,
    error: null
}

const onboardingSlice = createSlice({
    name: 'onboarding',
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder
        .addCase(fetchOrganizationProfile.pending, (state) => {
            state.error = null
            state.isLoading = true
        })
        .addCase(fetchOrganizationProfile.fulfilled, (state, action) => {
            state.organization = action.payload.organization
            state.contact = action.payload.contact
            state.error = null
            state.isLoading = false
        })
        .addCase(fetchOrganizationProfile.rejected, (state, action) => {
            state.error = action.payload as ErrorType ?? null
            state.isLoading = false
        })
        // Update Contact Person
        .addCase(fetchUpdateContactPerson.pending, (state) => {
            state.error = null
            state.isLoading = true
        })
        .addCase(fetchUpdateContactPerson.fulfilled, (state, action) => {
            state.organization = action.payload.organization
            state.contact = action.payload.contact
            state.error = null
            state.isLoading = false
        })
        .addCase(fetchUpdateContactPerson.rejected, (state, action) => {
            state.error = action.payload as ErrorType ?? null
            state.isLoading = false
        })
        .addCase(fetchSubmitForModeration.pending, (state) => {
            state.error = null
            state.isLoading = true
        })
        .addCase(fetchSubmitForModeration.fulfilled, (state, action) => {
            state.organization = action.payload.organization
            state.contact = action.payload.contact
            state.error = null
            state.isLoading = false
        })
        .addCase(fetchSubmitForModeration.rejected, (state, action) => {
            state.error = action.payload as ErrorType ?? null
            state.isLoading = false
        })
        .addCase(fetchDashboardStatus.pending, (state) => {
            state.error = null
            state.isLoading = true
        })
        .addCase(fetchDashboardStatus.fulfilled, (state, action) => {
            state.organization = action.payload.organization
            state.contact = action.payload.contact
            state.error = null
            state.isLoading = false
        })
        .addCase(fetchDashboardStatus.rejected, (state, action) => {
            state.error = action.payload as ErrorType ?? null
            state.isLoading = false
        })
    },
})

export const onboardingReducer = onboardingSlice.reducer
export default onboardingSlice.reducer

